import { LikeIcon } from 'ui/icons/LikeIcon';

import styles from '../DetailsProfile/DetailsProfile.module.scss';

interface Review {
  name: string;
  date: string;
  items: string[];
}

interface ReviewsItemProps {
  reviews: Review[];
  avatar: string;
}

export const ReviewsItem: React.FC<ReviewsItemProps> = ({ reviews, avatar }) => {
  return (
    <ul className={styles['profile-card-review__content-list']}>
      <h2>Отзывы о репетиторе</h2>

      {reviews.map((review, idx) => (
        <li key={idx} className={styles['profile-card-review__content-list-item']}>
          <div className={styles['profile-card-review__header']}>
            <div className={styles['profile-card-review-avatar']}>
              <img src={avatar} alt='avatar' />
              <LikeIcon />
            </div>
            <div className={styles['profile-card-review-info']}>
              <span className={styles['profile-card-review__name']}>{review.name}</span>
              <span className={styles['profile-card-review__date']}>{review.date}</span>
            </div>
          </div>
          <ul className={styles['profile-card-review__items']}>
            {review.items.map((text, i) => (
              <li key={i} className={styles['profile-card-review__item']}>
                {text}
              </li>
            ))}
          </ul>
        </li>
      ))}
    </ul>
  );
};
